import { Component, ViewChild } from '@angular/core';
import { ModulesManagerService } from '../../../classes/Module/modules-manager.service';
import { UsersAdmin } from '../../../classes/admin/users/users-admin';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})



export class UserComponent   {

  
  @ViewChild('confirmaction') confirmAlert;
  searchText= ""
  private datas:Array<UsersAdmin> = []

  constructor(public manager: ModulesManagerService) { 
  }

  get Datas(): Array<UsersAdmin>{
    return this.datas.filter((data)=> data.containValue(this.searchText)).sort((data1, data2)=> data1.Id - data2.Id)
  }

  public async Reload() {
    this.datas = []
    this.searchText = ""
    let res = await this.manager.Ws.Send("Admin", "Fetch", {module: "Users"}, true)
    if (res ) {
      if (res.error) return this.manager.Tool.notify(this.manager.Trad.Parse(res.error))
      this.datas = res.data.map((data)=>{
        let AdminUser = new UsersAdmin(this.manager)
        AdminUser.hydrate(data)
        return AdminUser
      })
    }
  }

  public async confirmContact() {
    this.confirmAlert.presentAlert({
      header: this.manager.Trad.Parse('STR_NEW_CONTACT'),
      message: this.manager.Trad.Parse('STR_NEW_CONTACT_DESCRIPTION'),
      cssClass: 'confirm-delete-alert',
      buttons: [
        {
          text: this.manager.Trad.Parse('STR_DELETE'),
          handler: ()=>{},
          cssClass: 'delete-button',
        },
        {
          text: this.manager.Trad.Parse('STR_EDIT'),
          handler: () => {},
          cssClass: 'edit-button',
        },
        {
          text: this.manager.Trad.Parse('STR_CLOSE'),
        },
      ],
    })
  }
}
